import React from 'react';

interface JobsPerPageSelectorProps {
  value: number;
  onChange: (value: number) => void;
}

const JobsPerPageSelector: React.FC<JobsPerPageSelectorProps> = ({ value, onChange }) => {
  return (
    <div className="flex items-center space-x-2">
      <label htmlFor="jobs-per-page" className="text-sm font-medium text-gray-700">
        Show:
      </label>
      <select
        id="jobs-per-page"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="block w-auto pl-3 pr-10 py-2 text-sm font-medium text-gray-800 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-purple focus:border-brand-purple hover:bg-gray-100 transition-colors"
      >
        <option value={20}>20</option>
        <option value={50}>50</option>
      </select>
    </div>
  );
};

export default JobsPerPageSelector;
